(function () {
  function initSoqiaWhyChoose(section) {
    if (!section || section.dataset.sliderReady === 'true') return;
    section.dataset.sliderReady = 'true';

    const track = section.querySelector('[data-track]');
    const slides = Array.from(section.querySelectorAll('[data-slide]'));
    const prevBtn = section.querySelector('[data-prev]');
    const nextBtn = section.querySelector('[data-next]');
    const dotsWrap = section.querySelector('[data-dots]');

    if (!track || slides.length === 0) return;

    const mobileMq = window.matchMedia('(max-width: 767px)');
    let activeIndex = 0;
    let ticking = false;

    function isMobile() {
      return mobileMq.matches;
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';

      if (slides.length < 2) return;

      slides.forEach((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sq-why__dot' + (index === activeIndex ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        dot.addEventListener('click', function () {
          goTo(index);
        });
        dotsWrap.appendChild(dot);
      });
    }

    function updateDots() {
      if (!dotsWrap) return;
      const dots = dotsWrap.querySelectorAll('.sq-why__dot');
      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === activeIndex);
      });
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;

      const disabled = !isMobile() || slides.length < 2;
      prevBtn.disabled = disabled || activeIndex <= 0;
      nextBtn.disabled = disabled || activeIndex >= slides.length - 1;
    }

    function getNearestIndex() {
      const scrollLeft = track.scrollLeft;
      let nearestIndex = 0;
      let nearestDistance = Infinity;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.offsetLeft - scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function syncStateFromScroll() {
      if (!isMobile()) return;
      activeIndex = getNearestIndex();
      updateDots();
      updateArrows();
    }

    function goTo(index, behavior = 'smooth') {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      activeIndex = safeIndex;

      if (isMobile()) {
        track.scrollTo({
          left: slides[safeIndex].offsetLeft,
          behavior: behavior
        });
      }

      updateDots();
      updateArrows();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(activeIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(activeIndex + 1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        if (!isMobile()) return;
        if (ticking) return;

        ticking = true;
        window.requestAnimationFrame(function () {
          syncStateFromScroll();
          ticking = false;
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (!isMobile()) {
        activeIndex = 0;
        track.scrollLeft = 0;
      } else {
        goTo(activeIndex, 'auto');
      }
      updateDots();
      updateArrows();
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (!section.contains(event.target)) return;
      const blockSlide = event.target.closest('[data-slide]');
      const slideIndex = slides.indexOf(blockSlide);
      if (slideIndex > -1) {
        goTo(slideIndex, 'smooth');
      }
    });

    buildDots();
    updateDots();
    updateArrows();
  }

  function initAllSoqiaWhyChoose(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-soqia-why-choose]');
    sections.forEach(initSoqiaWhyChoose);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllSoqiaWhyChoose(document);
    });
  } else {
    initAllSoqiaWhyChoose(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllSoqiaWhyChoose(event.target);
  });
})();